import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsNbsGift implements ICommand
{

	public UUID : string = "";
	public HostID : number = 0;
	public GiftID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.UUID = ba.readString();
		this.HostID = ba.readUint16();
		this.GiftID = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.UUID);
		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GiftID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsNbsGift();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'UUID(S)='+this.UUID+' ';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GiftID(Q)='+this.GiftID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55101;
	}

	public getCmdName() : string
	{
		return 'PsNbsGift';
	}

}
